module.exports = "../../../../platform/assets/pageMainIcon/yewuchulilei8.svg";